import { ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { Filtration } from "../summary/models/filter";

export class promotionConstants {

    public static readonly clientId = 'bFgPbasLw3fTisElFa6lCTH165ZZi3ka';
    public static readonly audience = 'https://promo.supplyocado.com/v1';

    public static readonly title = "Ocado";

    public static readonly defaultViewsList: any = [
        { columnDef: 'proposal_id', headerText: 'Proposal ID', width: '130', isVisible: true, isEditable: false },
        // { columnDef: 'product_start_date', headerText: 'Effective Start Date', width: '130', isVisible: true, isEditable: false },
        // { columnDef: 'product_end_date', headerText: 'Effective End Date', width: '130', isVisible: true, isEditable: false },
        // { columnDef: 'sfm_promotion_id', headerText: 'SFM Promo ID', width: '130', isVisible: true, isEditable: false },
        // { columnDef: 'sfm_promotion_status', headerText: 'SFM Status', width: '130', isVisible: true, isEditable: false },
        { columnDef: 'funding_amount', headerText: 'Trigger Funding Per Unit', format: 'n3', width: '150', isVisible: true, isEditable: true },
        { columnDef: 'promo_margin', headerText: 'Promo Margin', width: '120', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'promo_saving', headerText: 'Promo Saving', width: '150', isVisible: true, filterCode: 'promo_saving', sortCode: 'promo_saving' },
        { columnDef: 'funding', headerText: 'Funding %', width: '130', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'cost_price', headerText: 'Effective Cost Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'effective_retail_price', headerText: 'Effective Retail Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'current_retail_price', headerText: 'Current Retail Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'vat_rate', headerText: 'VAT', width: '120', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'effective_promo_price', headerText: 'Max Promo Price Per Unit', width: '150', isVisible: true, isEditable: false },
        { columnDef: 'proposal_start_date', headerText: 'Proposal Start Date', width: '130', isVisible: true, isEditable: false },
        { columnDef: 'proposal_end_date', headerText: 'Proposal End Date', width: '130', isVisible: true, isEditable: false },
        { columnDef: 'product_start_date', headerText: 'SKU Start Date', width: '160', isVisible: true, isEditable: false },
        { columnDef: 'product_end_date', headerText: 'SKU End Date', width: '130', isVisible: true, isEditable: false },
    ];
    public static readonly supplierDefaultViewsList: any = [
        { columnDef: 'funding_amount', headerText: 'Trigger Funding Per Unit', width: '150', format: 'n3', isVisible: true, isEditable: true },
        { columnDef: 'promo_margin', headerText: 'Promo Margin', width: '120', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'promo_saving', headerText: 'Promo Saving', width: '150', isVisible: true, filterCode: 'promo_saving', sortCode: 'promo_saving' },
        { columnDef: 'funding', headerText: 'Funding %', width: '130', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'cost_price', headerText: 'Effective Cost Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'current_retail_price', headerText: 'Current Retail Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'vat_rate', headerText: 'VAT', width: '120', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'current_promotion_price', headerText: 'Max Promo Price Per Unit', width: '150', isVisible: true, isEditable: false },
    ];

    public static readonly buyerDefaultViewsList: any = [
        { columnDef: 'funding_amount', headerText: 'Trigger Funding Per Unit', width: '150', format: 'n3', isVisible: true, isEditable: false },
        { columnDef: 'promo_margin', headerText: 'Promo Margin', width: '120', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'promo_saving', headerText: 'Promo Saving', width: '150', isVisible: true, filterCode: 'promo_saving', sortCode: 'promo_saving' },
        { columnDef: 'funding', headerText: 'Funding %', width: '130', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'cost_price', headerText: 'Effective Cost Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'effective_retail_price', headerText: 'Effective Retail Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'current_retail_price', headerText: 'Current Retail Price', width: '120', isVisible: true, isEditable: false },
        { columnDef: 'vat_rate', headerText: 'VAT', width: '120', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'effective_promo_price', headerText: 'Max Promo Price Per Unit', width: '150', isVisible: true, isEditable: false },
    ];

    public static readonly commercialViewsList: any = [
        { columnDef: 'off_Promo_Margin', headerText: 'Off Promo Margin', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'promo_Margin_No_Trigger', headerText: 'Promo M % No Trigger', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'department_Margin_Budget', headerText: 'Department Promo Margin YTD', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'department_Margin_YTD', headerText: 'Department Margin % YTD', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'category_Margin_YTD', headerText: 'Category Margin % YTD', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'subcategory_Margin_YTD', headerText: 'Subcategory Margin % YTD', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'yTD_Sales', headerText: 'YTD Sales', width: '150', isVisible: true, isEditable: false },
        { columnDef: 'sales_52week_value', headerText: 'L52W Sales', width: '150', isVisible: true, isEditable: false },
        { columnDef: 'ytd_margin_percent', headerText: 'YTD Margin', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'ytd_promo_margin_percent', headerText: 'YTD Promo Margin', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'l_52w_margin_percent', headerText: 'L52W Margin', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'l_52w_promo_margin_percent', headerText: 'L52W Promo Margin', width: '150', format: 'p2', isVisible: true, isEditable: false },
        { columnDef: 'tesco_Base_Index', headerText: 'Tesco Base Index', width: '150', format: { format: 'C2', useGrouping: false, minimumSignificantDigits: 1, maximumSignificantDigits: 3, currency: 'GBP' }, isVisible: true, isEditable: false },
        { columnDef: 'tesco_shelf_Index', headerText: 'Tesco Best Index', width: '150', format: { format: 'C2', useGrouping: false, minimumSignificantDigits: 1, maximumSignificantDigits: 3, currency: 'GBP' }, isVisible: true, isEditable: false },
        { columnDef: 'invoice_amount', headerText: 'Invoiced Total', width: '150', format: { format: 'C2', useGrouping: false, minimumSignificantDigits: 1, maximumSignificantDigits: 3, currency: 'GBP' }, isVisible: true, isEditable: false },
    ];

    public static readonly buyerColumnsList: any = [
        { id: 0, columnDef: 'id', headerText: 'ID', minwidth: '110', width: '110', isPrimaryKey: "true", isVisible: true, filterCode: 'promotion_id', sortCode: 'promotion_id', dynamicWidth: '6.7%', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { id: 1, columnDef: 'entity_type', headerText: 'Type', minwidth: '150', width: '150', isVisible: true, filterCode: 'entity_type', sortCode: 'entity_type', dynamicWidth: '9.15%', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 2, columnDef: 'status_id', headerText: 'Status', minwidth: '150', width: '150', isVisible: true, filterCode: 'status', sortCode: 'status_id', dynamicWidth: '8.7%', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 3, columnDef: 'supplier_name', headerText: 'Supplier', minwidth: '150', width: '150', isVisible: true, filterCode: 'supplier_name', sortCode: 'supplier_name', dynamicWidth: '9.25%', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { id: 4, columnDef: 'brand_name', headerText: 'Brand', minwidth: '110', width: '110', isVisible: true, filterCode: 'brand_name', sortCode: 'brand_name', dynamicWidth: '6.70%', operator_lov_code: 'LOV_TEXT_GROUP' },
        { id: 5, columnDef: 'promotion_type_value', headerText: 'Promo Type', minwidth: '110', width: '110', isVisible: true, filterCode: 'promotion_type', sortCode: 'promotion_type_value', dynamicWidth: '6.70%', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 6, columnDef: 'short_description_translated', headerText: 'Promo Description', minwidth: '130', width: '130', isVisible: true, filterCode: null, sortCode: 'short_description_translated', dynamicWidth: '8%', operator_lov_code: '' },
        { id: 7, columnDef: 'promotion_phase_name', headerText: 'Phase', minwidth: '110', width: '110', isVisible: true, filterCode: 'promotion_phase_id', sortCode: 'promotion_phase_id', dynamicWidth: '6.70%', operator_lov_code: 'LOV_TEXT_GROUP' },
        { id: 8, columnDef: 'promotion_start_date', headerText: 'Start Date', minwidth: '100', width: '100', format: 'yMd', isVisible: true, filterCode: 'start_date', sortCode: 'promotion_start_date', dynamicWidth: '6.2%', operator_lov_code: 'DATE_TIME_GROUP' },
        { id: 9, columnDef: 'promotion_end_date', headerText: 'End Date', minwidth: '100', width: '100', format: 'yMd', isVisible: true, filterCode: 'end_date', sortCode: 'promotion_end_date', dynamicWidth: '6.2%', operator_lov_code: 'DATE_TIME_GROUP' },
        { id: 10, columnDef: 'calc_promo_margin_percent', headerText: 'Avg Promo M', minwidth: '100', width: '100', format: 'p2', isVisible: true, filterCode: 'calc_promo_margin_percent', sortCode: 'calc_promo_margin_percent', dynamicWidth: '6.1%', operator_lov_code: 'LOV_NUMERIC_GROUP_BLANK' },
        { id: 11, columnDef: 'calc_customer_saving_percent', headerText: 'Avg Saving', minwidth: '110', width: '110', format: 'p2', isVisible: true, filterCode: 'calc_customer_saving_percent', sortCode: 'calc_customer_saving_percent', dynamicWidth: '6.70%', operator_lov_code: 'LOV_NUMERIC_GROUP_BLANK' },
        { id: 12, columnDef: 'calc_funding_percent', headerText: 'Avg Funding', minwidth: '100', width: '100', format: 'p2', isVisible: true, filterCode: 'calc_funding_percent', sortCode: 'calc_funding_percent', dynamicWidth: '6.2%', operator_lov_code: 'LOV_NUMERIC_GROUP_BLANK' },
        { id: 13, columnDef: 'calc_off_promo_margin', headerText: 'Avg Off Promo M', minwidth: '110', width: '110', format: 'p2', isVisible: true, filterCode: 'calc_off_promo_margin', sortCode: 'calc_off_promo_margin', dynamicWidth: '6.1%', operator_lov_code: 'LOV_NUMERIC_GROUP_BLANK' },
        { id: 14, columnDef: 'promotion_sub_type_value', headerText: 'Promotion SubType', minwidth: '120', width: '120', isVisible: false, filterCode: 'promotion_sub_type', sortCode: 'promotion_sub_type_value', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 15, columnDef: 'mechanic_type_value', headerText: 'Mechanic Type', minwidth: '120', width: '120', isVisible: false, filterCode: 'mechanic_type', sortCode: 'mechanic_type_value', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 16, columnDef: 'long_description_translated', headerText: 'Long Description', minwidth: '130', width: '130', isVisible: false, filterCode: null, sortCode: 'long_description_translated', operator_lov_code: '' },
        { id: 17, columnDef: 'entity_name', headerText: 'Promotion Name', minwidth: '150', width: '150', isVisible: false, filterCode: 'promotion_name', sortCode: 'entity_name', operator_lov_code: 'TEXT_GROUP' },
        { id: 18, columnDef: 'invoiced_total_amount', headerText: 'Invoiced Total', minwidth: '110', width: '110', isVisible: true, filterCode: 'invoiced_total_amount', sortCode: 'invoiced_total_amount', operator_lov_code: 'TEXT_GROUP' },
        { id: 19, columnDef: 'calc_buyer_name', headerText: 'Buyer', minwidth: '130', width: '130', isVisible: false, filterCode: 'buyer_id', sortCode: 'calc_buyer_name', operator_lov_code: 'LOV_TEXT_GROUP' },
        { id: 20, columnDef: 'created_by_name', headerText: 'Created By', minwidth: '130', width: '130', isVisible: false, filterCode: 'created_by', sortCode: 'created_by_name', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { id: 21, columnDef: 'created_at', headerText: 'Created Date', minwidth: '110', width: '110', format: 'yMd', isVisible: false, filterCode: null, sortCode: 'created_at', operator_lov_code: '' },
        { id: 22, columnDef: 'submitted_by_name', headerText: 'Submitted By', minwidth: '130', width: '130', isVisible: false, filterCode: 'submitted_by', sortCode: 'submitted_by_name', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { id: 23, columnDef: 'submitted_at', headerText: 'Submitted Date', minwidth: '125', width: '125', format: 'yMd', isVisible: false, filterCode: 'submitted_at', sortCode: 'submitted_at', operator_lov_code: 'DATE_GROUP' },
        { id: 24, columnDef: 'accepted_by_name', headerText: 'Accepted By', minwidth: '130', width: '130', isVisible: false, filterCode: null, sortCode: 'accepted_by_name', operator_lov_code: '' },
        { id: 25, columnDef: 'accepted_at', headerText: 'Accepted Date', minwidth: '140', width: '140', format: 'yMd', isVisible: false, filterCode: null, sortCode: 'accepted_at', operator_lov_code: '' },
        { id: 26, columnDef: 'approved_by_name', headerText: 'Approved By', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'approved_by_name', operator_lov_code: '' },
        { id: 27, columnDef: 'approved_at', headerText: 'Approved Date', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'approved_at', operator_lov_code: '' },
        { id: 28, columnDef: 'rejected_by_name', headerText: 'Rejected By', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'rejected_by_name', operator_lov_code: '' },
        { id: 29, columnDef: 'rejcect_reason_id', headerText: 'Rejection Reason', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'rejcect_reason_id', operator_lov_code: '' },
        { id: 30, columnDef: 'rejected_at', headerText: 'Rejected Date', minwidth: '130', width: '130', format: 'yMd', isVisible: false, filterCode: null, sortCode: 'rejected_at', operator_lov_code: '' },
        { id: 31, columnDef: 'live_date', headerText: 'Live Date', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'live_date', operator_lov_code: '' },
        { id: 32, columnDef: 'terminated_by_name', headerText: 'Terminated By', width: '140', isVisible: false, filterCode: null, sortCode: 'terminated_by_name', operator_lov_code: '' },
        { id: 33, columnDef: 'terminated_at', headerText: 'Terminated Date', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'terminated_at', operator_lov_code: '' },
        { id: 34, columnDef: 'item_ceiling', headerText: 'Limit Per Order', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'item_ceiling', operator_lov_code: '' },
        // { id: 35, columnDef: 'sfm_extracted_by_name', headerText: 'Extracted By', minwidth: '130', width: '130', isVisible: false, filterCode: 'extracted_by', sortCode: 'sfm_extracted_by_name', operator_lov_code: 'TEXT_GROUP' },
        // { id: 36, columnDef: 'sfm_extracted_at', headerText: 'Extracted Date', minwidth: '130', width: '130', isVisible: false, filterCode: 'extracted_at', sortCode: 'sfm_extracted_at', operator_lov_code: 'DATE_GROUP' },
        { id: 37, columnDef: 'last_live_edited_at', headerText: 'Live Edited Date', minwidth: '130', width: '130', isVisible: false, filterCode: null, sortCode: 'last_live_edited_at', operator_lov_code: '' }
    ];
    public static readonly supplierColumnsList: any = [
        { id: 0, columnDef: 'id', headerText: 'ID', minwidth: '110', width: '110', isPrimaryKey: "true", isVisible: true, filterCode: 'proposal_id', sortCode: 'proposal_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { id: 1, columnDef: 'status_id', headerText: 'Status', minwidth: '143', width: '143', isVisible: true, filterCode: 'status', sortCode: 'status_id', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 2, columnDef: 'brand_name', headerText: 'Brand', minwidth: '110', width: '110', isVisible: true, filterCode: 'brand_name', sortCode: 'brand_name', operator_lov_code: 'LOV_TEXT_GROUP' },
        { id: 3, columnDef: 'promotion_type_value', headerText: 'Promo Type', minwidth: '120', width: '120', isVisible: true, filterCode: 'promotion_type', sortCode: 'promotion_type_value', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 4, columnDef: 'short_description_translated', headerText: 'Promo Description', minwidth: '210', width: '210', isVisible: true, filterCode: null, sortCode: 'short_description_translated', operator_lov_code: '' },
        { id: 5, columnDef: 'promotion_phase_name', headerText: 'Phase', minwidth: '120', width: '120', isVisible: true, filterCode: 'promotion_phase_id', sortCode: 'promotion_phase_id', allowEditing: true, editType: 'dropdownedit', editColumn: 'phaseListDetails', operator_lov_code: 'LOV_TEXT_GROUP' },
        { id: 6, columnDef: 'promotion_start_date', headerText: 'Start Date', minwidth: '120', width: '120', format: 'yMd', isVisible: true, filterCode: 'start_date', sortCode: 'promotion_start_date', allowEditing: true, editType: 'datepickeredit', editColumn: 'updateStartDate', operator_lov_code: 'DATE_TIME_GROUP' },
        { id: 7, columnDef: 'promotion_end_date', headerText: 'End Date', minwidth: '120', width: '120', format: 'yMd', isVisible: true, filterCode: 'end_date', sortCode: 'promotion_end_date', allowEditing: true, editType: 'datepickeredit', editColumn: 'updateEndDate', operator_lov_code: 'DATE_TIME_GROUP' },
        { id: 8, columnDef: 'calc_customer_saving_percent', headerText: 'Promo Saving', minwidth: '150', width: '150', isVisible: true, filterCode: null, sortCode: 'calc_customer_saving_percent', operator_lov_code: '' },
        { id: 9, columnDef: 'calc_funding_percent', headerText: 'Funding', minwidth: '120', width: '120', isVisible: true, filterCode: null, sortCode: 'calc_funding_percent', operator_lov_code: '' },
        { id: 10, columnDef: 'promotion_sub_type_value', headerText: 'Sub Type', minwidth: '120', width: '120', isVisible: false, filterCode: 'promotion_sub_type', sortCode: 'promotion_sub_type_value', allowEditing: true, editType: 'dropdownedit', editColumn: 'subTypeDetails', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 11, columnDef: 'mechanic_type_value', headerText: 'Mechanic', minwidth: '120', width: '120', isVisible: false, filterCode: 'mechanic_type', sortCode: 'mechanic_type_value', allowEditing: true, editType: 'dropdownedit', editColumn: 'mechanicTypeDetails', operator_lov_code: 'LOV_GROUP_FIXED' },
        { id: 12, columnDef: 'long_description_translated', headerText: 'Long Description', minwidth: '210', width: '210', isVisible: false, filterCode: null, sortCode: 'long_description', operator_lov_code: '' },
        { id: 13, columnDef: 'entity_name', headerText: 'Proposal Name', minwidth: '150', width: '150', isVisible: false, filterCode: 'proposal_name', sortCode: 'entity_name', allowEditing: true, editColumn: 'updateProposalName', operator_lov_code: 'TEXT_GROUP' },
        { id: 14, columnDef: 'calc_buyer_id', headerText: 'Buyer', minwidth: '130', width: '130', isVisible: false, filterCode: 'buyer_id', sortCode: 'current_buyer_name', operator_lov_code: 'LOV_TEXT_GROUP' },
        { id: 15, columnDef: 'created_by_name', headerText: 'Created By', minwidth: '130', width: '130', isVisible: false, filterCode: 'created_by', sortCode: 'created_by_name', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { id: 16, columnDef: 'created_at', headerText: 'Created Date', minwidth: '110', width: '110', format: 'yMd', isVisible: false, filterCode: null, sortCode: 'created_at', operator_lov_code: '' },
        { id: 17, columnDef: 'submitted_by_name', headerText: 'Submitted By', minwidth: '130', width: '130', isVisible: false, filterCode: 'submitted_by', sortCode: 'submitted_by_name', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { id: 18, columnDef: 'submitted_at', headerText: 'Submitted Date', minwidth: '125', width: '125', format: 'yMd', isVisible: false, filterCode: 'submitted_at', sortCode: 'submitted_at', operator_lov_code: 'DATE_GROUP' },
        { id: 19, columnDef: 'accepted_by_name', headerText: 'Accepted By', minwidth: '130', width: '130', isVisible: false, filterCode: null, sortCode: 'accepted_by_name', operator_lov_code: '' },
        { id: 20, columnDef: 'accepted_at', headerText: 'Accepted Date', minwidth: '140', width: '140', format: 'yMd', isVisible: false, filterCode: null, sortCode: 'accepted_at', operator_lov_code: '' },
        { id: 21, columnDef: 'rejected_by_name', headerText: 'Rejected by', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'rejected_by_name', operator_lov_code: '' },
        { id: 22, columnDef: 'reject_reason_description', headerText: 'Rejection Reason', minwidth: '140', width: '140', isVisible: false, filterCode: null, sortCode: 'reject_reason_description', operator_lov_code: '' },
        { id: 23, columnDef: 'rejected_at', headerText: 'Rejected Date', minwidth: '130', width: '130', format: 'yMd', isVisible: false, filterCode: null, sortCode: 'rejected_at', operator_lov_code: '' }
    ];

    public static readonly descriptionRuleColumnsList: any[] = [
        { field: 'entity_type', headerText: 'Entity', width: '50', minWidth: '90' },
        { field: 'promotion_type_name', headerText: 'Promo Type', width: '70', minWidth: '130' },
        { field: 'mechanic_type_name', headerText: 'Mechanic Type', width: '70', minWidth: '150' },
        { field: 'promotion_sub_type_name', headerText: 'Sub Type', width: '60', minWidth: '120' },
        { field: 'short_description', headerText: 'Short Description Rule', width: '130', minWidth: '210' },
        { field: 'long_description', headerText: 'Long Description Rule', width: '210', minWidth: '300' },
        { field: 'updated_by_name', headerText: 'Updated By', width: '70', minWidth: '150' },
        { field: 'updated_at', headerText: 'Updated On', width: '70', minWidth: '130' },
    ];

    public static readonly promotionPhaseCalendarColumnsList: any[] = [
        { field: 'fiscal_year', headerText: 'Financial Year', width: '175' },
        { field: 'phase_description', headerText: 'Phase', width: '150' },
        {
            field: 'promotion_start_date', headerText: 'Start Date',
            width: '155'
        },
        {
            field: 'promotion_end_date', headerText: 'End Date', width: '155'
        },
        { field: 'promotion_deadline_days', headerText: 'Deadline(Days)', width: '185' },
        { field: 'promotion_deadline_date', headerText: 'Supplier Deadline', width: '195' },
        { field: 'updated_by_name', headerText: 'Updated By', width: '155' },
        { field: 'updated_at', headerText: 'Updated On', width: '155' },
    ];

    public static readonly invoiceColumnsList: any[] = [
        { field: 'invoice_status', headerText: 'Invoice Status', width: '50', minWidth: '90', filterCode: 'invoice_status', operator_lov_code: 'LOV_TEXT_GROUP' },
        { field: 'invoice_line_id', headerText: 'Invoice Line ID', width: '50', minWidth: '90', filterCode: 'invoice_line_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { field: 'promotion_id', headerText: 'Promotion ID', width: '60', minWidth: '110', filterCode: 'promotion_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { field: 'promotion_type', headerText: 'Promo Type', width: '50', minWidth: '110', filterCode: 'promotion_type', operator_lov_code: 'LOV_TEXT_GROUP' },
        { field: 'phase_description', headerText: 'Promo Phase', width: '50', minWidth: '110', filterCode: 'phase_description', operator_lov_code: 'LOV_TEXT_GROUP' },
        { field: 'product_no', headerText: 'SKU', width: '60', minWidth: '120', filterCode: 'product_no', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { field: 'product_description', headerText: 'Product Description', width: '130', minWidth: '150', filterCode: '', operator_lov_code: '' },
        { field: 'supplier_no', headerText: 'Supplier ID', width: '60', minWidth: '90', filterCode: 'supplier_no', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { field: 'supplier_name', headerText: 'Supplier Name', width: '70', minWidth: '150', filterCode: 'supplier_name', operator_lov_code: 'LOV_TEXT_GROUP' },
        { field: 'invoice_address', headerText: 'Supplier Address', width: '130', minWidth: '210', filterCode: '', operator_lov_code: '' },
        { field: 'contact_number', headerText: 'Supplier Contact', width: '70', minWidth: '130', filterCode: '', operator_lov_code: '' },
        { field: 'contact_email', headerText: 'Supplier Contact Email', width: '90', minWidth: '130', filterCode: '', operator_lov_code: '' },
        { field: 'ocado_contact', headerText: 'Ocado Contact', width: '90', minWidth: '130', filterCode: 'ocado_contact', operator_lov_code: 'LOV_TEXT_GROUP' },
        { field: 'trigger_funding', headerText: 'Trigger Funding', width: '90', minWidth: '130', filterCode: '', operator_lov_code: '' },
        { field: 'triggers', headerText: 'Triggers', width: '90', minWidth: '130', filterCode: '', operator_lov_code: '' },
        { field: 'sku_promo_from', headerText: 'SKU Promo From', width: '90', minWidth: '130', filterCode: 'sku_promo_from', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'sku_promo_to', headerText: 'SKU Promo To', width: '90', minWidth: '130', filterCode: 'sku_promo_to', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'promo_description', headerText: 'Promo Description', width: '90', minWidth: '130', filterCode: '', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'invoice_start_date', headerText: 'Invoice calculation start date', width: '90', minWidth: '130', filterCode: 'invoice_start_date', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'invoice_end_date', headerText: 'Invoice calculation end date', width: '90', minWidth: '130', filterCode: 'invoice_end_date', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'invoice_extracted_date', headerText: 'Extracted date', width: '90', minWidth: '130', filterCode: 'invoice_extracted_date', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'invoice_description', headerText: 'Invoice Description', width: '90', minWidth: '130', filterCode: '', operator_lov_code: '' },
        { field: 'invoice_funding_amount', headerText: 'Invoice Amount', width: '90', minWidth: '130', filterCode: 'invoice_funding_amount', operator_lov_code: 'LOV_NUMERIC_GROUP' },
        { field: 'vat', headerText: 'VAT', width: '90', minWidth: '130', filterCode: '', operator_lov_code: '' },
        { field: 'finance_invoice_date', headerText: 'Invoice Date', width: '90', minWidth: '130', filterCode: 'finance_invoice_date', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'invoice_finance_id', headerText: 'Finance Invoice Number', width: '90', minWidth: '130', filterCode: 'invoice_finance_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
    ];

    public static readonly customerGroupsColumnsList: any[] = [
        { field: 'customer_group_id', headerText: 'Customer Group ID', width: '120', minWidth: '150', filterCode: 'customer_group_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { field: 'customer_group_name', headerText: 'Customer Group Name', width: '120', minWidth: '150', filterCode: 'customer_group_name', operator_lov_code: 'TEXT_GROUP' },
        { field: 'promotion_id', headerText: 'Promo ID', width: '90', minWidth: '100', filterCode: 'promotion_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP' },
        { field: 'number_of_customers', headerText: 'No. of Customer IDs', width: '120', minWidth: '150', filterCode: 'number_of_customers', operator_lov_code: '' },
        { field: 'description', headerText: 'Description', width: '110', minWidth: '150', filterCode: 'description', operator_lov_code: 'TEXT_GROUP' },
        { field: 'customer_group_type', headerText: 'Customer Group Type', width: '120', minWidth: '150', filterCode: 'customer_group_type', operator_lov_code: '' },
        { field: 'status', headerText: 'Status', width: '70', minWidth: '100', filterCode: 'status', operator_lov_code: 'LOV_GROUP_FIXED' },
        { field: 'created_by_name', headerText: 'Created by', width: '110', minWidth: '140', filterCode: 'created_by', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { field: 'created_at', headerText: 'Created on', width: '100', minWidth: '120', filterCode: 'created_at', operator_lov_code: 'DATE_TIME_GROUP' },
        { field: 'updated_by_name', headerText: 'Updated by', width: '110', minWidth: '140', filterCode: 'updated_by', operator_lov_code: 'LOV_TYPEAHEAD_SEARCH' },
        { field: 'updated_at', headerText: 'Updated on', width: '100', minWidth: '120', filterCode: 'updated_at', operator_lov_code: 'DATE_TIME_GROUP' },
    ];

    public static readonly customerGroupReqColumnsList: any[] = [

        {
            id: 0,
            field: 'cg_request_id',
            columnDef: 'cg_request_id',
            headerText: 'Request ID',
            width: '120',
            minWidth: '120',
            filterCode: 'cg_request_id',
            operator_lov_code: 'NUMERIC_OPERATOR_GROUP',
            isVisible: true,
            sortCode: 'cg_request_id'
        },
        {
            id: 1,
            field: 'request_category',
            columnDef: 'request_category',
            headerText: 'Request Category',
            width: '160',
            minWidth: '180',
            filterCode: 'request_category',
            operator_lov_code: 'LOV_GROUP_FIXED',
            isVisible: true,
            sortCode: 'request_category'
        },
        {
            id: 2,
            field: 'cg_request_source',
            columnDef: 'cg_request_source',
            headerText: 'Source',
            width: '100',
            minWidth: '80',
            filterCode: 'cg_request_source',
            operator_lov_code: 'LOV_GROUP_FIXED',
            isVisible: true,
            sortCode: 'cg_request_source'
        },
        {
            field: 'promotion_id', headerText: 'Promo ID', width: '90', minWidth: '100', filterCode: 'promotion_id', operator_lov_code: 'NUMERIC_OPERATOR_GROUP', isVisible: true,
            sortCode: 'promotion_id'
        },
        {
            id: 3,
            field: 'promotion_type_name',
            columnDef: 'promotion_type_name',
            headerText: 'Promo Type',
            width: '120',
            minWidth: '120',
            filterCode: 'promotion_type',
            operator_lov_code: 'LOV_GROUP_FIXED',
            isVisible: true,
            sortCode: 'promotion_type'
        },
        {
            id: 4,
            field: 'p_name',
            columnDef: 'p_name',
            headerText: 'Promotion Name',
            width: '180',
            minWidth: '150',
            filterCode: 'p_name',
            operator_lov_code: 'TEXT_GROUP',
            isVisible: true,
            sortCode: 'p_name'
        },
        {
            id: 5,
            field: 'p_status_id',
            columnDef: 'p_status_id',
            headerText: 'Promo Status',
            width: '130',
            minWidth: '130',
            filterCode: 'p_status_id',
            operator_lov_code: 'LOV_GROUP_FIXED',
            isVisible: true,
            sortCode: 'p_status_id'
        },
        {
            id: 6,
            field: 'ud_custom_group_name',
            columnDef: 'ud_custom_group_name',
            headerText: 'CG Criteria Name',
            width: '150',
            minWidth: '150',
            filterCode: 'target_customers',
            operator_lov_code: 'LOV_GROUP_FIXED',
            isVisible: true,
            sortCode: 'target_customers'
        },
        {
            id: 7,
            field: 'cg_status',
            columnDef: 'cg_status',
            headerText: 'CG Request Status',
            width: '150',
            minWidth: '180',
            filterCode: 'cg_status',
            operator_lov_code: 'LOV_GROUP_FIXED',
            isVisible: true,
            sortCode: 'cg_status'
        },
        {
            id: 8,
            field: 'created_by_name',
            columnDef: 'created_by_name',
            headerText: 'Requested By',
            width: '160',
            minWidth: '180',
            filterCode: 'created_by',
            operator_lov_code: 'LOV_TYPEAHEAD_SEARCH',
            isVisible: true,
            sortCode: 'created_by_name'
        },
        {
            id: 9,
            field: 'created_at',
            columnDef: 'created_at',
            headerText: 'Requested Date',
            width: '160',
            minWidth: '180',
            filterCode: 'created_at',
            operator_lov_code: 'DATE_TIME_GROUP',
            isVisible: true,
            sortCode: 'created_at'
        },
        {
            id: 10,
            field: 'number_of_customers',
            columnDef: 'number_of_customers',
            headerText: 'No.of Customer IDs',
            width: '170',
            minWidth: '190',
            filterCode: '',
            operator_lov_code: 'NUMERIC_OPERATOR_GROUP',
            isVisible: true,
            sortCode: 'number_of_customers'
        },
        {
            id: 11,
            field: 'customer_group_id',
            columnDef: 'customer_group_id',
            headerText: 'Customer Group ID',
            width: '140',
            minWidth: '160',
            filterCode: 'customer_group_id',
            operator_lov_code: 'NUMERIC_OPERATOR_GROUP',
            isVisible: true,
            sortCode: 'customer_group_id'
        },
        {
            id: 12,
            field: 'generated_customer_ids',
            columnDef: 'generated_customer_ids',
            headerText: 'Generated Customer IDs',
            width: '190',
            minWidth: '220',
            filterCode: 'generated_customer_ids',
            operator_lov_code: 'STRING_OPERATOR_GROUP',
            isVisible: true,
            sortCode: 'generated_customer_ids'
        },
        {
            id: 13,
            field: 'response_time',
            columnDef: 'response_time',
            headerText: 'Response Time',
            width: '150',
            minWidth: '170',
            filterCode: 'response_time',
            operator_lov_code: 'STRING_OPERATOR_GROUP',
            isVisible: true,
            sortCode: 'response_time'
        },
        {
            id: 14,
            field: 'response_error',
            columnDef: 'response_error',
            headerText: 'Response Error',
            filterCode: 'response_error',
            operator_lov_code: 'STRING_OPERATOR_GROUP',
            width: '220',
            minWidth: '250',
            isVisible: true,
            sortCode: 'response_error'
        }
    ];

    public static readonly gridPageSizes = [ '50', '100', '150', '200', '500' ];
    public static readonly entityTypeReqId = 'LV_ENT_TYP_GEN';
    public static readonly promotionTypeReqId = 'LV_PRM_TYP_PRM';
    public static readonly promotionSubTypeReqId = 'LV_PRM_SUBTYPE_PRM';
    public static readonly mechanicTypeReqId = 'LV_MECH_TYP_PRM';
    public static readonly wizardProposalTypeReqId = 'LV_PRM_TYP_PRP_WIZ';
    public static readonly wizardPromotionTypeReqId = 'LV_PRM_TYP_PRM_WIZ';
    public static readonly wizardRewardTypeReqId = 'LV_RWD_PRP_WIZ';
    public static readonly wizardPrmRewardTypeReqId = 'LV_RWD_PRM_WIZ';
    public static readonly wizardRewardExampleTypeReqId = 'LV_RWD_EXP_PRP_WIZ';
    public static readonly wizardPrmRewardExampleTypeReqId = 'LV_RWD_EXP_PRM_WIZ';
    public static readonly wizardMechanicDropdownReqId = 'LV_MECH_LST_PRP_WIZ';
    public static readonly wizardPrmMechanicDropdownReqId = 'LV_MECH_LST_PRM_WIZ';
    public static readonly wizardMechanicTypeReqId = 'LV_MECH_TYP_PRP_WIZ';
    public static readonly wizardPrmMechanicTypeReqId = 'LV_MECH_TYP_PRM_WIZ';
    public static readonly wizardMechanicExampleTypeReqId = 'LV_MECH_TYP_EXP_PRP_WIZ';
    public static readonly wizardPrmMechanicExampleTypeReqId = 'LV_MECH_TYP_EXP_PRM_WIZ';
    public static readonly rejectReasonReqId = 'LV_REJECTED_REASON';
    public static readonly withdrawReasonReqId = 'LV_WITHDRAW_REASON';
    public static readonly terminateReasonReqId = 'LV_TERMINATE_REASON';
    public static readonly productGrpListLovId = 'PRODUCT_GROUP_LIST';
    public static readonly customerGrpListLovId = 'CUSTOMER_GROUP_LIST';
    public static readonly targetCustGrpListLovId = 'TARGET_CUSTOMER_GROUP_LIST';
    public static readonly combinedCfcListLovId = 'TARGET_CG_INCLUSION_CFC';
    public static readonly combinedProductListLovId = 'LOV_TARGET_CUSTOMER_PRODUCT_GROUP';
    public static readonly customPromoPhase = {
        promotion_phase_id: 0,
        phase_description: 'Custom Phase',
        promotion_start_date: '',
        promotion_end_date: '',
        promotion_deadline_days: 0,
    };
    public static readonly tokenReqId = 'LV_RUL_DESC_TOKEN';
    public static readonly britishDateFormat = 'dd/MM/yyyy';

    public static readonly promotionValidationMessages = {
        proposalName: [
            { type: 'invalidData', message: 'Please remove spaces' },
            { type: 'required', message: 'Enter a Proposal Name' },
            { type: 'maxLength', message: 'Maximum 255 letters only allowed' },
        ],
        reward: [
            { type: 'min', message: 'Reward must be greater than 0' },
            { type: 'max', message: 'Reward must be less than or equal to 100' },
            { type: 'invalidNegativeNumber', message: 'Reward must be a number' },
        ],
        triggerQuantity: [
            { type: 'required', message: 'Enter valid Trigger Quantity' },
            { type: 'min', message: 'Trigger Quantity must be greater than 1' },
            { type: 'max', message: 'Trigger Quantity must be equal to 1' },
            { type: 'invalidNegativeNumber', message: 'Trigger Quantity must be a number' },
            { type: 'invalidPositiveNumber', message: 'Enter valid Trigger Quantity in whole numbers only' },
        ],
        reqQuantity: [
            { type: 'required', message: 'Enter valid required quantity in basket' },
            { type: 'min', message: 'Required quantity in basket must be greater than 1' },
            { type: 'max', message: 'Required quantity in basket must be equal to 1' },
            { type: 'invalidNegativeNumber', message: 'Required quantity in basket must be a number' },
            { type: 'invalidPositiveNumber', message: 'Enter valid required quantity in basket in whole numbers only' },
        ],
        filter: [
            { type: 'invalidData', message: '*Enter a valid value' },
            { type: 'notRequired', message: '*Value is required' },
            { type: 'noBetweenSpaceValidation', message: '*Please remove additional spaces' },
        ],
        startdates: [
            { type: 'required', message: 'Enter the Promotion start date' },
            { type: 'datesEqual', message: 'Promotion start date is same as Promotion end date' },
            { type: 'min', message: 'Promotion start date cannot be a past date' },
            { type: 'minMore', message: 'Promotion start date is greater than Promotion end date' }
        ],
        enddates: [
            { type: 'required', message: 'Enter the Promotion end date' },
            { type: 'datesEqual', message: 'Promotion start date is same as Promotion end date' },
            { type: 'min', message: 'Promotion end date cannot be a past date' },
            { type: 'minMore', message: 'Promotion start date is greater than Promotion end date' }
        ],
        groupName: [
            { type: 'required', message: 'Enter a Group name' },
            { type: 'invalidData', message: 'Please remove spaces' },
            { type: 'invalidDecimal', message: 'Enter valid Group name' },
            { type: 'duplicate', message: 'Duplicate group name added as part of the promotion' },
            { type: 'sameName', message: 'Duplicate group name added as part of the promotion' }
        ],
        itemCeiling: [
            // { type: 'min', message: 'Enter whole numbers in XXXX format only' },
            { type: 'required', message: 'Cannot be blank' },
            { type: 'invalidDecimalItemCeiling', message: 'Enter whole numbers in XXXX format only' },
            { type: 'max', message: 'Enter whole numbers in XXXX format only' }
        ]
    };
    public static readonly proposalValidationMessages = {
        proposalName: [
            { type: 'required', message: 'Enter a Proposal Name' },
            { type: 'maxLength', message: 'Maximum 255 letters only allowed' }
        ],
        discount: [
            { type: 'required', message: 'Enter a Reward' },
            { type: 'invalidDecimal', message: 'Enter valid reward' },
            { type: 'invalidMaxAndMinNumber', message: 'Reward should be greater than 0 and less than 100' }
        ],
        groupName: [
            { type: 'required', message: 'Enter a Group name' },
            { type: 'invalidData', message: 'Please remove spaces' },
            { type: 'invalidDecimal', message: 'Enter valid Group name' },
            { type: 'duplicate', message: 'Duplicate group name added as part of the proposal' },
            { type: 'sameName', message: 'Duplicate group name added as part of the proposal' }
        ],
        requiredQtyInBasket: [
            { type: 'required', message: 'Enter a Required Quantity' },
            { type: 'min', message: 'Required Quantity must be greater than 0' },
            { type: 'min2', message: 'Required quantity in basket must be greater than 1' },
            { type: 'invalidPositiveNumber', message: 'Enter valid Required Quantity' },
            { type: 'max', message: 'Enter valid Required Quantity' },
            { type: 'invalidRequiredQuantity', message: 'Enter valid Required Quantity' }
        ],
        startdates: [
            { type: 'required', message: 'Enter the Proposal start date' },
            { type: 'datesEqual', message: 'Proposal start date is same as Proposal end date' },
            { type: 'min', message: 'Proposal start date cannot be a past date' },
            { type: 'minMore', message: 'Proposal start date is greater than Proposal end date' }
        ],
        enddates: [
            { type: 'required', message: 'Enter the Proposal end date' },
            { type: 'datesEqual', message: 'Proposal start date is same as Proposal end date' },
            { type: 'min', message: 'Proposal end date cannot be a past date' },
            { type: 'minMore', message: 'Proposal start date is greater than Proposal end date' }
        ],
        shortDesc: [
            { type: 'required', message: 'Enter short description' },
            { type: 'invalidData', message: 'Please remove spaces' }
        ],
        longDesc: [
            { type: 'required', message: 'Enter long description' },
            { type: 'invalidData', message: 'Please remove spaces' }
        ],

    };
    public static readonly webshopReqId = 'LV_WEBSHOP_PRM';
    public static readonly productQuantity = 1;

    public static readonly supplierFieldsReqId = 'SUPPLIER_SEARCH_FILTER';
    public static readonly buyerFieldsReqId = 'BUYER_SEARCH_FILTER';
    public static readonly financeFieldsReqId = 'FINANCE_SEARCH_FILTER';
    public static readonly customerGrpFieldsReqId = 'CUSTOMER_GROUP_FILTER';
    public static readonly customerGrpReqFieldsReqId = 'CUSTOMER_GROUP_REQ_FILTER';
    public static readonly ruleFieldsReqId = 'RULE_SEARCH_FILTER';
    public static readonly supplierStatusReqId = {
        "req_lov_id": "LV_WKFLW_STATUS",
        "lov_depend_code": "PRP"
    };
    public static readonly buyerStatusReqId = {
        "req_lov_id": "LV_WKFLW_STATUS",
        "lov_depend_code": "PRM"
    };
    public static readonly buyerSfmStatusReqId = {
        "req_lov_id": "LV_WKFLW_STATUS_SFM",
        "lov_depend_code": "PRM"
    };
    public static readonly invoiceStatusReqId = {
        "req_lov_id": "INVOICE_STATUS",
        "lov_depend_code": null
    };
    public static readonly cgStatusReqId = {
        "req_lov_id": "LV_CUST_GRP_STATUS",
        "lov_depend_code": "CG"
    };
    public static readonly errorWarningType = {
        "req_lov_id": "ERROR_WARNING_TYPE",
        "lov_depend_code": null
    };
    public static readonly conditionList = [ { lov_code: 'and', lov_value: 'and' }, { lov_code: 'or', lov_value: 'or' } ];
    public static readonly yesNoList = [ { lov_code: 'Yes', lov_value: 'Yes' }, { lov_code: "No", lov_value: "No" } ];

    public static readonly rewardMaxValidator = Validators.max(100);
    public static readonly triggerMultibuyMaxValidator = Validators.max(1);
    public static readonly requiredValidator = Validators.required;
    public static readonly htmlPattern = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
    public static readonly imgPattern = /<img\b[^>]*\bsrc = "[^"]*"[^>]*>/g;


    public static readonly validateGroupName: ValidatorFn = (): ValidationErrors | null => {
        return { duplicate: true };
    };

    public static readonly readOnly = 'PROMO_READ_ONLY';

    public static readonly rolePermission = {
        proposalDetails: {
            role_id: "NA",
            screen_id: "NA",
            status: "NA",
            proposal_webshop: "NA",
            promotion_webshop: "NA",
            group_group_detail: { read: false, write: false },
            group_group_sequence: { read: false, write: false },
            group_add_product: { read: false, write: false },
            group_product_grid: { read: false, write: false },
            side_bar_Audit: { read: false, write: false },
            side_bar_Comments: { read: false, write: false },
            side_bar_details: { read: false, write: false },
            side_bar_Invoice: { read: false, write: false },
            group_group_add: { read: false, write: false },
            add_label: { read: false, write: false },
            product_selection: { read: false, write: false },
            reject_sku_btn: { read: false, write: false }
        },
        promotionDetails: {
            role_id: "NA",
            screen_id: "NA",
            status: "NA",
            proposal_webshop: "NA",
            promotion_webshop: "NA",
            group_group_detail: { read: false, write: false },
            group_group_sequence: { read: false, write: false },
            group_add_product: { read: false, write: false },
            group_product_grid: { read: false, write: false },
            side_bar_Audit: { read: false, write: false },
            side_bar_Comments: { read: false, write: false },
            side_bar_details: { read: false, write: false },
            side_bar_Invoice: { read: false, write: false },
            group_group_add: { read: false, write: false },
            add_label: { read: false, write: false },
            pomotion_change_date: { read: false, write: false },
            promotion_name: { read: false, write: false },
            sub_type: { read: false, write: false },
            promo_inline_rule_change: { read: false, write: false },
            product_change_date: { read: false, write: false },
            product_update_trigger: { read: false, write: false }
        },
        summary: {
            role_id: 'NA',
            screen_id: 'summary',
            status: 'NA',
            proposal_webshop: 'NA',
            promotion_webshop: 'NA',
            main_create_promotion: { read: false, write: false },
            main_create_proposal: { read: false, write: false },
            add_label: { read: false, write: false },
            save_filter: { read: true, write: true },
        },
        notification: {
            role_id: 'NA',
            screen_id: 'notification',
            status: 'NA',
            inbox_button: { read: false, write: false },
            unread_button: { read: false, write: false },
            mention_button: { read: false, write: false },
            status_button: { read: false, write: false },
            error_button: { read: false, write: false }
        },
        manageLabels: {
            role_id: "NA",
            screen_id: "NA",
            status: "NA",
            proposal_webshop: "NA",
            promotion_webshop: "NA",
            create_label: { read: false, write: false },
            delete_label: { read: false, write: false }
        },
        manageInvoice: {
            role_id: "PROMO_FINANCE",
            screen_id: "manage-invoice",
            status: "N/A",
            proposal_webshop: "N/A",
            promotion_webshop: "UK_OCADO",
            download: {
                read: false,
                write: false
            },
            "manage-invoice": {
                read: false,
                write: false
            },
            upload: {
                read: false,
                write: false
            }
        }
    };

    public static readonly errorCodes = {
        roleNotExists: "ROLE_NOT_EXISTS",
        userNotExists: "USER_NOT_EXISTS",
        criticalIssue: "CRITICAL_ISSUE",
        nightlyBatch: "NIGHTLY_BATCH",
        systemMaintenance: "SYSTEM_MAINTENANCE",
        errUnAuth: "ERR_UNAUTH",
        errTokenExp: "ERR_TOKEN_EXP",
        backChannelLogout: "BC_LOGOUT",
        cgrNoCriteriaToSubmit: "CGR_NO_CRITERIA_TO_SUBMIT"
    };

    public static readonly encryptionKey = 'myTotallySecretKey';

    public static readonly pageSize: number = 50;
    public static readonly ProductGridPageSize: number = 50;
    public static readonly productGridPageSizes = [ '50', '100', '150', '200' ];
    public static readonly promotionsStoreName: string = 'promotions';
    public static readonly proposalsStoreName: string = 'proposals';
    public static readonly indexedDBName: string = 'detailsPageDB';

    public static readonly defaultFilter: Filtration = {
        filter: [
        ],
        sort: {
            field: null,
            display_field: '',
            type: null
        },
        pagination: {
            page_number: 1,
            page_size: this.pageSize,
        },
        reqCount: true,
        change_post_extraction: false
    };

    public static readonly defaultFilterCGR: Filtration = {
        filter: [
        ],
        sort: {
            field: null,
            display_field: '',
            type: null
        },
        pagination: {
            page_number: 1,
            page_size: this.pageSize,
        },
        reqCount: true,
        change_post_extraction: false
    };

    public static readonly defaultInvoiceFilter: Filtration = {
        "filter": [
            {
                "condition": "and",
                "field": "invoice_status",
                "display_field": "Invoice status",
                "display_value": "Calculated",
                "operator": "Equal",
                "type": "string",
                "value": "C",
                "operator_lov_code": "LOV_TEXT_GROUP"
            },
            {
                "condition": "and",
                "field": "invoice_funding_amount",
                "display_field": "Invoice Amount",
                "display_value": "0",
                "operator": "Greater Than",
                "type": "string",
                "value": "0",
                "operator_lov_code": "LOV_NUMERIC_GROUP"
            }
        ],
        "sort": {
            "field": null,
            "display_field": "",
            "type": null
        },
        "pagination": {
            "page_number": 1,
            "page_size": this.pageSize,
        }
    };

    public static readonly noSpaceFields = [
        {
            field: 'proposal_id',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'product_no',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'promotion_id',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'sfm_promo_id',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'calc_customer_saving_percent',
            operator: [ 'Equal' ]
        },
        {
            field: 'calc_funding_percent',
            operator: [ 'Equal' ]
        },
        {
            field: 'calc_promo_margin_percent',
            operator: [ 'Equal' ]
        },
        {
            field: 'calc_off_promo_margin',
            operator: [ 'Equal' ]
        },
        {
            field: 'supplier_no',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'invoice_finance_id',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'invoice_line_id',
            operator: [ 'Equal', 'Not Equal' ]
        },
        {
            field: 'invoice_funding_amount',
            operator: [ 'Equal' ]
        },
        {
            field: 'invoiced_total_amount',
            operator: [ 'Equal' ]
        },
    ];

    public static readonly noBetweenSpaceValidation = [
        {
            field: 'proposal_id',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'product_no',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'sfm_promo_id',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'promotion_id',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'comments',
            operator: [ 'Contains', 'Not Contain', 'Equal' ]
        },
        {
            field: 'proposal_name',
            operator: [ 'Contains', 'Not Contain', 'Equal' ]
        },
        {
            field: 'calc_customer_saving_percent',
            operator: [ 'Greater Than', 'Greater Than and Equal', 'Less Than', 'Less Than and Equal' ]
        },
        {
            field: 'calc_funding_percent',
            operator: [ 'Greater Than', 'Greater Than and Equal', 'Less Than', 'Less Than and Equal' ]
        },
        {
            field: 'calc_promo_margin_percent',
            operator: [ 'Greater Than', 'Greater Than and Equal', 'Less Than', 'Less Than and Equal' ]
        },
        {
            field: 'calc_off_promo_margin',
            operator: [ 'Greater Than', 'Greater Than and Equal', 'Less Than', 'Less Than and Equal' ]
        },
        {
            field: 'supplier_no',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'invoice_finance_id',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'invoice_line_id',
            operator: [ 'In', 'Not In' ]
        },
        {
            field: 'invoice_funding_amount',
            operator: [ 'Greater Than', 'Greater Than and Equal', 'Less Than', 'Less Than and Equal' ]
        },
        {
            field: 'invoiced_total_amount',
            operator: [ 'Greater Than', 'Greater Than and Equal', 'Less Than', 'Less Than and Equal' ]
        },
    ];

    public static readonly notRequiredValidation = [
        {
            field: 'comments',
            operator: [ 'Is Null', 'Is Not Null' ]
        },
        {
            field: 'short_description',
            operator: [ 'Is Null', 'Is Not Null' ]
        },
        {
            field: 'customer_group_name',
            operator: [ 'Is Null', 'Is Not Null' ]
        },
        {
            field: 'description',
            operator: [ 'Is Null', 'Is Not Null' ]
        },
        {
            field: 'proposal_name',
            operator: [ 'Is Null', 'Is Not Null' ]
        },
        {
            field: 'promotion_name',
            operator: [ 'Is Null', 'Is Not Null' ]
        },
        {
            field: 'assigned_to',
            operator: [ 'Is blank' ]
        },
        {
            field: 'extracted_by',
            operator: [ 'Is blank' ]
        },
        {
            field: 'extracted_date',
            operator: [ 'Is blank' ]
        },
        {
            field: 'sfm_promo_status',
            operator: [ 'Is blank' ]
        },
        {
            field: 'sfm_promo_id',
            operator: [ 'Is blank' ]
        },
        {
            field: 'invoiced_total_amount',
            operator: [ 'Is blank' ]
        },
        {
            field: 'calc_customer_saving_percent',
            operator: [ 'Is blank' ]
        },
        {
            field: 'calc_funding_percent',
            operator: [ 'Is blank' ]
        },
        {
            field: 'calc_promo_margin_percent',
            operator: [ 'Is blank' ]
        },
        {
            field: 'calc_off_promo_margin',
            operator: [ 'Is blank' ]
        },
        {
            field: 'customer_group_id',
            operator: [ 'Is Null', 'Is Not Null' ]
        }
    ];

    public static readonly temProductGroup = [
        { product_no: '+', funding_amount: '', uom_number: '', image_path: '', product_description: '', size_description: '' }, { product_no: '', funding_amount: '', uom_number: '' },
        { product_no: '', funding_amount: '', uom_number: '' },
        { product_no: '', funding_amount: '', uom_number: '' }
    ];

    public static readonly Proposal_Group_Type_Obj = { buy: "B", reward: "R" };
    public static readonly Prop_Item_Group_Type_obj = { B: "B", R: "R" };

    public static readonly Proposal_Type_Obj = {
        Redu: "Redu",
        Mult: "Mult",
        Bund: "Bund",
        Comb: "Comb",
        Link: "Link",
        Text: "Text",
    };

    public static readonly Proposal_Mechanic_Type_Obj = {
        FREE: "FREE",
        FIX: "FIX",
        DISC: "DISC",
        POFF: "POFF",
    };

    public static readonly PROPOSAL_TYPE_LONG_DESC_APPEND_DEC = [
        'Redu',
        'Mult',
        'Comb',
        'Link',
    ];

    public static readonly LONG_DESC_APPEND_OCT_DEC = {
        start_date: '2020-10-15',
        end_date: '2020-12-19',
        Long_Desc: `Not applicable for deliveries 20th-24th December`
    };

    public static readonly Offer_Sub_Type_obj = { Black_Friday: 'BFD', Clearance: 'CLR' };

    public static readonly Offer_Sub_Type_Name = {
        [ promotionConstants.Offer_Sub_Type_obj.Black_Friday ]: 'Black Friday',
    };

    public static readonly Offer_Sub_Type = [
        this.Offer_Sub_Type_obj.Black_Friday,
    ];

    public static readonly Description_KeyWord_Match = {
        minus: "_minus_",
        one: "one",
        last: "last",
        all: "all_",
        buy: "buy",
        required_quantity_in_basket: "required_quantity_in_basket",
        reward: "reward_amount",
        trigger_quantity: "trigger_quantity",
        current: "current",
        effective: "effective",
        current_promotion_price: "current_promotion_price",
        effective_promo_price: "effective_promo_price",
        req_qty_last: "@required_quantity_in_basket.last"
    };

    public static readonly Description_Type = {
        Short: "Short",
        Long: "Long",
    };

    public static readonly Redu_Poff_Short_Variation = {
        fifty: "Half Price, was £@Retail_Price",
        thirtythree: "Save 1/3, was £@Retail_Price",
        fifty_value: 50.0,
        thirtythree_value: 33.33,
    };

    public static readonly Mult_Poff_Short_Variation = {
        fifty: "Buy any @Trigger_Quantity, save @Reward%.",
        thirtythree: "Buy any @Trigger_Quantity, save 1/3.",
        twntyfive: "Buy 1, add 2nd Half Price.",
        fifty_value: 50.0,
        thirtythree_value: 33.33,
        twetyfive_value: 25.0,
    };

    public static readonly Redu_Poff_Long_Variation = {
        fifty: "Half Price",
        thirtythree: "Save 1/3",
        fifty_value: 50.0,
        thirtythree_value: 33.33,
        replace: "Save @Reward%",
    };

    public static readonly Mult_Free_Short_Variation = {
        TQ_two_Reward_one: "Buy one, get one free",
        // TQ_three_Reward_one: "Buy any 2, add 1 free.",
        // TQ_Reward_Greater_Then_one: "Buy any @Trigger_Quantity for @Trigger-Reward_Quanity"
    };

    public static readonly Mult_Short_Variation_Replace = {
        replace_value: "any ",
        replace_with: "",
    };

    public static readonly P_Group_Delete_Crud_Status = "DELETE";

    public static readonly Date_Column_Names = [
        "promotion_start_date",
        "promotion_end_date",
    ];

    public static readonly Mult_Long_Desc_Postfix =
        "Order by @promotion_End_Date, offer subject to availability. Maximum @max_promo_item promotional items per customer.";

    public static readonly Convert_to_Int_Column_Names = [ "item_ceiling" ];

    public static readonly Bund_Comb_Link_Match_Reward_Value = {
        pound: "£@Reward",
        percent: "@Reward%",
    };

    public static readonly Bund_Comb_Link_Replace_Reward_Value = {
        fifty: "Half Price",
        thirtythree: "1/3",
        fifty_value: 50.0,
        thirtythree_value: 33.33,
    };

    public static readonly Convert_to_decimal_Column_Names = [ "reward_amount" ];

    public static readonly Proposal_Response_File_Name: any = {
        products: "products",
    };
    public static readonly Dialog_Messages: any = {
        "rejected": "Rejected",
        "delete_reject_header": "Deleted & Rejected",
        "failure": "Failure",
        "download_failure_title": "Download failure",
        "download_failure_message": "Unable to download the file",
        "ok_button": "OK",
        "delete_icon": "icon-delete-circle-solid",
        "check_icon": "icon-check-circle-solid",
        "warning_icon": "icon-warning",
        "exceed_message": "You have exceeded the maximum number",
        "label_exist_title": "The labels already exist",
        "label_exist_message": "The label already exists",
        "label_exist_message_extends": " in the list and",
        "label_alert_title": "Label Alert!",
        "label_alert_cannot_message": 'cannot be created.',
        "invalid_label": 'Invalid Label name',
        "label_special_message": 'Label name cannot have special characters.',
        "label_exceed_message": 'Label name cannot exceed 20 characters',
        "label_already_message": 'The labels have been added to',
        "label_removed_success": "Labels Removed Successfully",
        "label_removed_message": "The labels have been removed.",
        "label_already_message_dot": 'The labels have been added.',
        "label_success_message": 'Labels added successfully',
        "label_delete_title": 'Labels deleted successfully',
        "label_delete_message": 'The labels have been deleted from',
        "label_already_exist": 'The label already exists in the list and',
        "in_the": 'the list',
        "mark_download": 'Do you want to mark the downloaded',
        "download_success": 'Download Successful',
        "download_success_message": 'Selected Invoice Line IDs\ndownloaded successfully.',
        "duplicate_error": 'Duplicate group name added as part of the promotion',
        "duplicate_error_prp": 'Duplicate group name added as part of the proposal',
        "delete_promotion_title": 'Promotion deleted',
        "delete_promotion_message": 'The promotion has been deleted',
        "reasons_header": "Select Rejection Reason",
        "reasons_reason": "Rejection Reason",
        "delete_and_reject": "Deleted and proposals have been rejected",
        "delete_and_reject_header": "Delete Promotion & Reject associated Proposal",
        "promotion_already": "The promotion has already been",
        "proposal_already": "The proposal has already been",
        "terminated": "terminated",
        "terminate": "terminate",
        "wrong_request": "Wrong Request",
        "promotion_terminated": "Promotion Terminated",
        "promotion_rejected": "Promotion Rejected",
        "terminated_promotion": "Terminated Promotion",
        "promotion_terminated_success": "The Promotion has been Terminated",
        "promotion_deleted": "The Promotion has been Deleted",
        "promotion_associated": "Promotion Deleted and Associated Proposal Rejected",
        "proposal_rejeced": "the associated proposals are rejected",
        "delete_promotion": 'Delete Promotion',
        "proposal_delete": "Proposal deleted",
        "proposal_rejected": "Proposal Rejected",
        "proposal_delete_success": "The proposal has been deleted",
        "promotion_download": 'Promotion Downloaded',
        "are_permanently_delete": 'Are you sure you want to permanently delete?',
        "are_withdraw": 'Are you sure you want to withdraw?',
        "approval_failure": 'Approval Failure',
        "approval_success": 'Approved',
        "publish_success": 'Published',
        "publish_success_msg": "has been published to OSP successfully",
        "publish_failure": "Publish Failed",
        "publish_msg_failure": "Could not be published to OSP as no Customers IDs are associated with",
        "message_failure": 'Approval failed as no Customer IDs are associated with',
        "approval_failure_issue": 'Approval failure due to one or more issues.',
        "approval_high_volume_issue": 'Approval failure due to high volume.',
        "approval_high_volume_issue_1": 'Please select lower volume.',
        "approval_general_issue": 'Approval failure due to internal issue errors.',
        "approval_general_issue_1": 'Please raise it to Help Scout.',
        "no_sku": 'No SKUs added to the group',
        "promotion_draft": 'Promotion has been saved in draft.',
        "withdraw_title": 'Withdraw Proposal',
        "promotion_validation": "Promotion validation",
        "proposal_validation": 'Proposal validation',
        "promotion_approved": 'Promotion Approved',
        "promotion_approved_message": "The Promotion has been approved.",
        "request_withdraw": "Request Withdrawal",
        "request_for_withdraw": "request for withdrawal",
        "reject_proposal": "Reject Proposal",
        "reject": "reject",
        "agree_withdraw": "Agree to Withdrawal",
        "agree_request_withdraw": "agree the request for withdraw",
        "merge": "Merge",
        "comments": "comments",
        "assign_to": "Assign Proposal to",
        "delete_associate": "delete? The associated proposals will be rejected.",
        "proposal_withdraw": "The Proposal has been",
        "proposal_withdrawn": "Proposal Withdrawn",
        "proposal_withdrawn_message": "The Proposal has been withdrawn",
        "withdraw_failure": "Withdrawal Failure",
        "withdraw_failure_message": "The Proposal could not be withdrawn. Refresh the page and try again.",
        "edit_failure": "Edit Failure",
        "edit_failure_message": "The Proposal could not be re-opened for editing. Refresh the page and try again.",
        "associate_proposal": "Any associated proposals have become independent draft promotions.",
        "promotion_downloaded_message": "The promotion has been downloaded",
        "proposal_promotion_download": 'Proposals / Promotions Downloaded',
        "proposal_promotion_download_success": 'All Reduction/Multibuy/Text/Smart Pass/Sales Based Invoicing have been downloaded successfully.',
        "proposal_submitted": 'Proposal submission',
        "in_sfm_format": "in SFM format",
        "number_validation": 'It should be numeric and upto 3 decimal places',
        "trigger_funding_negative": 'Trigger Funding Per Unit should not be negative',
        "trigger_funding_max": 'Trigger Funding Per Unit should not be greater than 9999.999',
        "trigger_funding_required": 'Enter a Trigger Funding Per Unit',
        "trigger_funding_editable": "Trigger Funding cannot be edited as invoice is already generated",
        "delete_confirm": 'Are you sure you want to Delete',
        "delete_confirm_header": 'Delete Confirmation',
        "yes": "Yes",
        "no": "No",
        "success": "Success",
        "success_content": "Success content",
        "error_catch_weight": 'Catchweight items is not valid for this mechanic',
        "error_invalid": 'Invalid SKU',
        "error_save_percent": 'Enter Save %',
        "error_save_percent_negative": 'The Reward (Save %) field should not be ‘negative’',
        "error_save_percent_100": 'The Reward (Save %) entered should not be equal to or greater than 100',
        "error_save_percent_33": 'Enter valid reward for Save % in whole numbers only. (exception-33.33%)',
        "error_save_percent_0": 'The Reward (Save %) entered should not be 0',
        "error_save_pound": 'Enter Save £',
        "error_save_pound_negative": 'The Reward (Save £) field cannot be a negative',
        "error_save_pound_0": 'The Reward (Save £) field cannot be 0',
        "error_valid_format": 'Enter valid reward. Format £XXXX.XX',
        "error_fixed_offer": 'Enter Fixed Offer Price',
        "error_fixed_offer_negative": 'The Reward (Fixed offer) field should not be ‘negative’',
        "error_fixed_offer_0": 'The Reward (Fixed offer) should not be 0',
        "error_free": 'Enter Free reward',
        "error_free_negative": 'The Reward field should not be ‘negative’',
        "error_free_number": 'Enter valid reward for Free in whole numbers only',
        "error_min": 'The Reward field cannot be 0',
        "error_trigger_min": 'The Reward field should be less than Trigger Quantity',
        "warning_reward": 'The Reward (Save %) entered is either below 10% or above 60%',
        "promotion_phase_added": "Promotion Phase Added",
        "promotion_phase_added_success": "The Promotion Phase has been added successfully.",
        "promotion_phase_update": "Promotion Phase Updated",
        "promotion_phase_update_success": "The Promotion Phase has been updated successfully.",
        "update_failure": "Update Failure",
        "save_failure": "Save Failure",
        "submit_failure": "Submission Failure",
        "update_failure_associated": "Unable to edit the end date due to association with proposal/promotion.",
        "delete_phase": 'Delete Promotion Phase',
        "delete_phase_associated": 'All the associated promotions in deleted status will be deleted permanently.',
        "promotion_phase_delete": 'Promotion Phase Deleted',
        "promotion_phase_delete_success_1": 'The Promotion Phase has been',
        "promotion_phase_delete_success_2": 'deleted successfully.',
        "delete_failure": 'Deletion Failure',
        "delete_failure_message_1": 'Please delete the last phase before',
        "delete_failure_message_2": 'deleting subsequent phases.',
        "delete_failure_message_3": 'Unable to delete a phase due to',
        "delete_failure_message_4": 'associations with Proposal/Promotion.',
        "operation_failure": "Operation Failure",
        "assoicate_promotion_live": " Associated Promotion is already live.",
        "buyer_directly": "Please contact the buyer directly.",
        "withdraw_Accepted": 'Withdrawal Accepted',
        "withdraw_Accepted_success": 'You have successfully accepted withdrawal for this proposal',
        "withdraw_Accepted_promotion_failure": 'Withdrawal was accepted, but the associated promotion could not be updated.',
        "promotion_created": "Promotion Created",
        "accept_failure": 'Accept Failure',
        "submit_proposal": "Submit Proposal",
        "submit_proposal_terms": "By submitting, you agree to the",
        "terms_conditions": "Promotion Terms & Conditions",
        "accept_failure_message": 'Unable to accept the proposal.',
        "submission_failure": "Submission Failure",
        "submission_failure_message": 'Unable to submit the proposal.',
        "proposal_submit": "Proposal Submitted",
        "proposal_submit_message": "The Proposal has been submitted.",
        "deleted": "deleted",
        "submitted": "submitted",
        "withdrawn": "withdrawn",
        "req_withdrawn": "requested for withdrawal",
        "req_withdrawn_c": "Requested for Withdrawal",
        "rule_update": 'Rule Updated Successfully',
        "rule_update_success": 'The Rule has been updated',
        "rule_added_success": 'The Rule has been added',
        "rule_added_success_message": 'The Rule has been added',
        "successfully": 'successfully.',
        "limit_255": 'Enter maximum 255 characters',
        "mal_format": 'Unsupported or mal-formatted message',
        "exceed_due_date": 'Exceeded due date. Please submit immediately',
        "sumbit_due_date": 'Submit within the next 2 weeks',
        "sumbit_due_date_last": 'Submit before the due date',
        'warning': 'Warning',
        "errors_not_include": 'Errors will not be included in the proposal.',
        "errors_not_include_prm": 'Errors will not be included in the promotion.',
        "proceed": 'Do you wish to proceed?',
        "draft_prp_crt": 'Draft Proposal Created',
        "rem_prp_discard": 'All remaining proposals will be discarded.',
        "delete_view": "Are you sure you want to delete the view?",
        "choose_option": 'Choose an option',
        "overwrite": 'Do you want to overwrite the current view or',
        "save_new": 'save this as a new view?',
        "save_new_message": 'Save as new view',
        "overwrite_message": 'Overwrite current view',
        "filter_save": 'Filter Saved in My View',
        "view_delete": 'View Deleted',
        "view_save": 'You have successfully saved the filter',
        "filter_delete": 'The filter has been deleted from My',
        "please_check_view": 'Please check in My View.',
        "view_limit": 'Saved View Limit',
        "view_limit_message": 'You have reached the maximum number of',
        "view_limit_message_extend": 'saved views. Please delete one to proceed further.',
        "all_prp_discard": "All remaining proposals will be discarded.",
        "all_prm_discard": "All remaining promotions will be discarded.",
        "take_summary": "You will be taken to summary view.",
        "icon_info_circle": "icon-info-circle",
        "icon_info_circle_solid": "icon-info-circle-solid",
        "alert": "Alert!",
        "download_several": "The download may take several minutes,",
        "download_several_extend": "We will notify you once the download is completed",
        "download_first": 'Downloaded the first ',
        "redu_mult_text": ' Reduction/Multibuy/Text records successfully. Maximum download limit is ',
        "delete_proposal": "Delete Proposal",
        "permanently_delete": 'permanently delete?',
        "question_withdraw": 'withdraw?',
        "unmerge_conflict": 'Draft Promotion could not be created due to conflict check',
        "unmerge_failure": 'Unmerge Failure',
        "unmerge_success": 'Unmerge Successful',
        "delete_reject": "Delete Promotions and Reject Associated Proposals",
        "delete_and_reject_c": "Delete & Reject",
        "promotion_have": " The Promotion have been",
        "promotion_has": "The Promotion has been",
        "proposal_has": "The Proposal has been",
        "download_sfm": "downloaded in SFM format.",
        "download_sfm_c": 'Downloaded SFM Failure',
        "download_combination": 'You can download in combination of',
        "redu_mult_text_or_combo_link": 'Redu/Multibuy/Text Or Combo/Link/Bundle.',
        "bulk_edit": 'Bulk edit',
        "no_longer": 'is no longer in draft status',
        "no_longer_live": "is no longer in Live status.",
        "no_longer_submit": 'is no longer in submitted status',
        "no_longer_draft_approved": 'is no longer in submitted status',
        "no_longer_accepted": 'as it is no longer in accepted status',
        "withdrawn_c": 'Withdrawn',
        "one_more": 'One or more proposal could not be',
        "submitted_error": 'submitted due to errors',
        "accepted_error": 'accepted due to errors',
        "associate_promotion": 'Associated promotions have already gone live,',
        "tabs_limit": 'You have exceeded the maximum number of permitted tabs. Please close an existing tab to open new promotion',
        "select_id": "Selected proposals/promotions merged into promotion ID ",
        "icon_cancel_solid": 'icon-cancel-solid',
        "icon_error_circle_solid": 'icon-error-circle-solid',
        "merge_failure": "Merge Failure",
        "merge_success": "Merge Successful",
        "merge_pink": 'Unable to merge, impacted proposals are highlighted as an error',
        "draft_promotion_created": "Draft Promotion Created",
        "upload_successful": "Upload Successful",
        "records_validated": "records successfully validated",
        "any_proposal": "Any associated proposals will become independent draft promotions.",
        "accepted_proposal": "Any accepted proposals will become independent draft promotions.",
        "withdraw_accept": "Any withdrawal request will be accepted.",
        "one_proposal": "This promotion has only one associated proposal.",
        "continue_del_rej": "Click continue to Delete & Reject?",
        "multiple_proposals": "Promotions with multiple proposals will become independent draft promotions.",
        "one_associated_proposal": "Promotions with only one associated proposal will be deleted and rejected.",
        "continue": "Do you wish to continue?",
        "accepted_proposal_done": "Any accepted proposals have become independent draft promotions.",
        "withdraw_accept_done1": "Any withdrawal requests have been accepted.",
        "withdraw_accept_done2": "Any withdrawal request has been accepted.",
        "multiple_proposals_done": "Promotions with multiple proposals have become independent draft promotions.",
        "one_associated_proposal_done": "Promotions with only one associated proposal have been deleted.",
        "permanently_delete_msg": "Do you wish to permanently delete?",
        "report_download_message": "The report has been downloaded successfully.",
        "cancel_button": "Cancel",
        "continue_btn": "Continue",
        'warning_with_exclamation': 'Warning!',
        "submit_proposal_pe_warnings": "One or more SKUs have Price Establishment warnings. Do you wish to continue?",
        "submit_proposal_pe_warnings_summary": "One or more SKUs in the selected Proposals have Price Establishment warnings. Do you wish to continue?",
        "conflict_check_in_progress": "Conflict check still in progress.",
        "pe_validation_in_progress": "PE validation still in progress.",
        "conflict_check_failed": "Conflict check failed.",
        "differenceMassage": "SKU dates are different from the proposal dates.",
        "prmDifferenceMassage": "SKU dates are different from the promotion dates.",
        "approve_live_edit": "Approve Edit",
        "approve_live_edit_confirm": "Do you want to approve changes to the live promotion?",
        "cancel_live_edit": "Cancel Edit",
        "cancel_live_edit_confirm": "Are you sure you want to cancel edit? All unsaved changes will be lost.",
        "approve_live_edit_fail": "Approval Failure",
        "approve_live_edit_fail_msg": "Approval failure due to one or more issues. Changes to live promotion could not be approved.",
        "approved": "Approve",
        "approve_live_edit_msg": "All changes to live promotion have been approved and sent to the website.",
        "live_edit_cancel": "Live Edit Cancelled",
        "live_edit_cancel_msg": "All unsaved changes have been lost.",
        "liveDifferenceMessage": "SKU dates are different from the proposal/promotion dates",
        "liveedit_error_title": "Error",
        "liveedit_error_message": "currently live editing the promo. You can not make any changes from the summary screen.",
        "liveedit_error_message_comment": "currently live editing the promo. You can not make any comment.",
        "same_buyer_error_message": "1 or more promotions are being live edited by",
        "different_buyer_error_message": "1 or more promotions are being live edited by 1 or more buyers.",
        "liveedit_summary_error_message": "You can not make any changes from the summary screen.",
        "bultEditFailure": "Bulk edit Failure",
        "buldEditSuccess": "The promotions are saved",
        "bulkEditFailedValidation": "could not be updated due to failed date validations.",
        "liveEditFailure": "Live Edit Failure",
        "liveEditConflict": "Unable to save changes due to conflict check failure",
        "live_edit_restrict": "Live Edit is restricted as this promotion is managed in SFM",
        "upload_proposal_header": "Uploads with errors will need to be fixed on the upload sheet and uploaded again before draft proposals can be created.",
        "upload_promotion_header": "Uploads with errors will need to be fixed on the upload sheet and uploaded again before draft promotions can be created.",
        "customer_group_header": "Customer IDs with errors will need to be fixed on the upload sheet and uploaded again before adding to the Customer Group",
        "copy_customer_ids_header": "Copy existing table data from a spreadsheet (like an Excel workbook or Google Sheet) and paste it in the field below.",
        "customer_group_upload_header": "Drag and drop your Excel file into the upload area, or click “Browse File” to select it manually.",
        "coupons_promo_manage_product_subHeader": "Any products added here will be automatically applied to all groups you create.",
        "customer_group_wizard_subHeader": "Please specify the customer reward in £0.00 format.",
        "customer_group_wizard_subHeader_nextLine": "Recommended minimum reward level should be equivalent to at least 20% (30% for New Customers).",
        "save_customer_text": " Customer Records Added",
        "save_customer_subtext": "Total Customer IDs are now ",
        "customer_cancel_msg": "Changes Cancelled",
        "customer_id_replace_text": "Replace Customer IDs",
        "customer_id_replace_subtext": "Are you sure you want to replace",
        "customer_group_download_success": "Customer group record downloaded",
        "cg_create_success": "Customer Group Created Successfully",
        "cg_create_failure": "Customer Group Creation Failure",
        "cg_update_failure": "Customer Group Edit Failure",
        "cg_already_exist": "name already exists. Please choose a different name",
        "cg_request_success": "CG Request Submitted",
        "cg_request_success_msg": "CG Request submitted successfully for criteria management",
        "cg_request_failure": "CG Request Failure",
        "customer_record": "No Customer Records Added",
        "customer_error_msg": "All customer IDs have errors. Please review and upload again.",
        "cg_submitted1": "Promotion is submitted for criteria management.",
        "cg_submitted2": "Withdraw criteria in order to edit.",
        "cg_progress1": "Criteria management is in progress.",
        "cg_progress2": "Criteria cannot be withdrawn.",
        "request_overview_header": "Customer Group Request Overview",
        "request_overview_subheader": "This information has been entered by the supplier for the coupon promotion.",
        "request_overview_sub_header": "(Fields marked with an asterisk (*) are mandatory.)",
        "target_criteria_header": "Targeting Criteria",
        "target_criteria_subheader": "Enrich the targeting criteria for the customer group request",
        "cg_criteria_header": "Select Customer Group Criteria",
        "cg_criteria_subheader": "You can choose to continue with existing CG Criteria or select a different criteria.",
        "cg_criteria_sub_header": "Changes will be reconciled with the promotion if linked.",
        "history_target_header": "History-Based Targeting",
        "history_target_subheader": "You may enhance the targeting criteria of the customer group request based on SKUs/Brand/Hierarchy.",
        "custom_target_header": "Custom Targeting Criteria (Inclusion)",
        "custom_target_subheader": "Any SKUs/Brands/Hierarchies that a customer MUST have bought in the last 12 weeks",
        "custom_target_exc_header": "Custom Targeting Criteria (Exclusion)",
        "custom_target_exc_subheader": "Any SKUs/Brands/Hierarchies that a customer MUST NOT have bought in the last 12 weeks",
        "bag_target_header": "In The Bag Targeting",
        "bag_target_subheader": "SKUs/Brands/Hierarchies that a customer must/ must not have in the basket for a future order",
        "itb_target_header": "Selection Criteria (Inclusion)",
        "itb_target_subheader": "Any SKUs/Brands/Hierarchies that a customer MUST have in the basket for a future order",
        "itb_target_exc_header": "Selection Criteria (Exclusion)",
        "itb_target_exc_subheader": "Any SKUs/Brands/Hierarchies that a customer MUST NOT have in the basket for a future order",
        "cgr_save_title": "Changes have been saved",
        "cgr_save_msg": "Submission not yet completed.",
        "cgr_submit_title": "CG criteria review is completed",
        "cgr_submit_msg": "Customer ID generation has been initiated",
        "cgr_nothing_to_submit_title": "Nothing to submit",
        "cgr_nothing_to_submit_msg": "Add coupon criteria and save the promotion before submitting.",
        "cgr_approve_msg": "has been approved successfully",
        "desired_list_size_msg": "The maximum size of the customer list in total for the coupon",
        "specific_customer_numbers_msg": "If you know your personal Ocado customer number, please add here (comma separated)",
        "inclusion_cfc_ids_msg": "CFC IDs that a customer must belong to",
        "inclusions_and_msg": "Customer attribute flags. Customers must match ALL OF THEM in order to be eligible",
        "inclusions_or_msg": "Customer attribute flags. Customers must match at least ONE of them in order to be eligible",
        "product_contains_msg": "Customer attribute flags. Customers HAS NOT match ANY of the flags in order to be eligible",
        "order_start_date_msg": "Delivery dates on which a customer must have an order placed/delivered. Dates can be in the future or past.",
        "extra_targeting_skus_msg": "Any SKUs that should be used in the targeting INSTEAD OF the SKU list displayed in the Overview section",
        "inclusion_history_brand_msg": "Any brands that a customer HAS bought in the last 12 weeks",
        "inclusion_history_hierarchy_msg": "Any hierarchies that a customer HAS bought in the last 12 weeks. You can specify either DEPT, DEPT>CAT or DEPT>CAT>SUBCAT",
        "inclusion_history_skus_msg": "Any SKUs that a customer HAS bought in the last 12 weeks",
        "exclusion_history_brand_msg": "Any brands that a customer HAS NOT bought in the last 12 weeks",
        "exclusion_history_hierarchy_msg": "Any hierarchies that a customer HAS NOT bought in the last 12 weeks. You can specify either DEPT, DEPT>CAT or DEPT>CAT>SUBCAT",
        "exclusion_history_skus_msg": "Any SKUs that a customer HAS NOT bought in the last 12 weeks",
        "inclusion_itb_brand_msg": "Any brands that a customer HAS in the basket for a future order",
        "inclusion_itb_hierarchy_msg": "Any hierarchies that a customer HAS in the basket for a future order. You can specify either DEPT, DEPT>CAT or DEPT>CAT>SUBCAT",
        "inclusion_itb_skus_msg": "Any SKUs that a customer HAS in the basket for a future order",
        "exclusion_itb_brand_msg": "Any brands that a customer DOES NOT have in the basket for a future order",
        "exclusion_itb_hierarchy_msg": "Any hierarchies that a customer DOES NOT have in the basket for a future order. You can specify either DEPT, DEPT>CAT or DEPT>CAT>SUBCAT",
        "exclusion_itb_skus_msg": "Any SKUs that a customer DOES NOT have in the basket for a future order",
        "summary_restrict_action": "One or more promotions are submitted for criteria management. Withdraw criteria in order to perform any action.",
        "summary_restrict_approve_action": "One or more promotions have not been assigned customer groups. Please wait until the customer groups are assigned to take the approval action.",
        "action_denied": "Action Denied",
        "already_assigned": "The Customer Group is already",
        "already_assigned_subtext": "assigned to one or more promotions."
    };

    public static readonly Waffle_application_list = [
        {
            "application_id": "suphub",
            "name": "OcadoHub",
            "description": "Gateway to supplier services",
            "icon": "icon-rocket-solid",
            "dev": "https://dev.ocadohub.com",
            "tst": "https://tst.ocadohub.com",
            "ppd": "https://ppd.ocadohub.com",
            "prod": "https://ocadohub.com",
            "colour": "#B18DB9",
            "active": true,
            "staff_only": null
        },
        {
            "application_id": "promo",
            "name": "Promotions",
            "description": "Managing funded promotions",
            "icon": "icon-offer-solid",
            "dev": "https://dev-promo.ocadohub.com",
            "tst": "https://test-promo.ocadohub.com",
            "ppd": "https://ppd-promo.ocadohub.com",
            "prod": "https://promo.ocadohub.com",
            "colour": "#EAAD25",
            "active": true,
            "staff_only": null
        },
        {
            "application_id": "commercial",
            "name": "Commercial",
            "description": "Managing funded Commercial",
            "icon": "icon-like-solid",
            "dev": "https://dev-commercial.ocadohub.com",
            "tst": "https://tst-commercial.ocadohub.com",
            "ppd": "https://ppd-commercial.ocadohub.com",
            "prod": "https://commercial.ocadohub.com",
            "colour": "#9BC1DE",
            "active": true,
            "staff_only": null
        },
        {
            "application_id": "learn",
            "name": "Learn",
            "description": "Managing funded Learn",
            "icon": "icon-blanket-solid",
            "dev": "https://ocadohub.learnstaging.link",
            "tst": "https://ocadohub.learnstaging.link",
            "ppd": "https://ocadohub.learnstaging.link",
            "prod": "https://ocadohub.learn.link",
            "colour": "#E4A9BB",
            "active": true,
            "staff_only": null
        },
        {
            "application_id": "media",
            "name": "Ads Manager",
            "description": "Managing funded Ads",
            "icon": "icon-bullseye-solid",
            "dev": "https://ocado.au.zitcha.dev/",
            "tst": "https://ocado.au.zitcha.dev/",
            "ppd": "https://ocado.au.zitcha.dev/",
            "prod": "https://ocado.uk.zitcha.app/",
            "colour": "#FC905E",
            "active": true,
            "staff_only": null
        },
        {
            "application_id": "insights",
            "name": "Insights",
            "description": "Managing funded Insights",
            "icon": "icon-bar-chart-alt-2",
            "dev": "https://www.beet-insight.com",
            "tst": "https://www.beet-insight.com",
            "ppd": "https://www.beet-insight.com",
            "prod": "https://www.beet-insight.com",
            "colour": "#98115E",
            "active": false,
            "staff_only": null
        },
        {
            "application_id": "supplychain",
            "name": "Demand",
            "description": "Managing purchase order",
            "icon": "icon-truck-solid",
            "dev": "https://olive.ocado.com/",
            "tst": "https://olive.ocado.com/",
            "ppd": "https://olive.ocado.com/",
            "prod": "https://olive.ocado.com/",
            "colour": "#CDC272",
            "active": false,
            "staff_only": null
        },
        {
            "application_id": "walnut",
            "name": "Walnut",
            "description": "Ocado Retail Leanring",
            "icon": "icon-brain-solid",
            "dev": "https://orl.learn.link",
            "tst": "https://orl.learn.link",
            "ppd": "https://orl.learn.link",
            "prod": "https://orl.learn.link",
            "colour": "#CFB69C",
            "active": true,
            "staff_only": true
        },
    ];

    public static readonly menuBtnIcons: any = {
        'Download SFM': 'e-icons icon-download',
        'Delete': 'e-icons icon-delete-solid',
        'Withdraw': 'e-icons icon-withdraw',
        'Submit': 'e-icons icon-send',
        'Request Withdrawal': 'e-icons icon-withdraw',
        'Reject Proposal': 'e-icons icon-x-circle',
        'Accept & Save Draft': 'e-icons icon-check-shield',
        'Accept & Approve': 'e-icons icon-check-double',
        'Delete & Reject': 'e-icons icon-block',
        'Open': 'e-icons icon-folder',
        'Accept Withdrawal': 'e-icons icon-check-square',
        'Assign CA': 'e-icons icon-user-check',
        'Terminate': 'e-icons icon-no-entry',
        'Approve': 'e-icons icon-check-square',
        'Unmerge': 'e-icons icon-layer-minus',
    };

    public static readonly auditIcons: any = {
        'Accepted': '../../../../assets/icons/audit-icons/icon-accepted-audit.png',
        'Draft': '../../../../assets/icons/audit-icons/icon-created-audit.png',
        'ReDraft': '../../../../assets/icons/audit-icons/icon-created-audit.png',
        'Invoice Supplier Update': '../../../../assets/icons/audit-icons/icon-created-audit.png',
        'Live': '../../../../assets/icons/audit-icons/icon-live-audit.png',
        'Assigned': '../../../../assets/icons/audit-icons/icon-assigned-audit.png',
        'UnAssigned': '../../../../assets/icons/audit-icons/icon-assigned-audit.png',
        'Extracted': '../../../../assets/icons/audit-icons/icon-extracted-audit.png',
        'Rejected': '../../../../assets/icons/audit-icons/icon-rejected-audit.png',
        'Approved': '../../../../assets/icons/audit-icons/icon-approved-audit.png',
        'Deleted': '../../../../assets/icons/audit-icons/icon-terminated-audit.png',
        'Terminated': '../../../../assets/icons/audit-icons/icon-terminated-audit.png',
        'Submitted': '../../../../assets/icons/audit-icons/icon-submitted-audit.png',
        'Withdraw_Requested': '../../../../assets/icons/audit-icons/icon-withdrawn-audit.png',
    };

    public static readonly peFilter = {
        condition: "and",
        display_field: "Status",
        display_value: "Deleted, Terminated, Ended, Expired",
        field: "status",
        operator: "Not In",
        operator_lov_code: "LOV_GROUP_FIXED",
        type: "string",
        value: [ "Deleted", "Terminated", "Ended", "Expired" ]
    };

}